const KEY='knsaix.providerMarket.uiProblems.v3';
const MAX=100;
const store=()=>{try{return typeof window!=='undefined'?window.localStorage:null}catch{return null}};
export function sanitizeDiagnosticText(input){
 let text=String(input??'').slice(0,1600);
 const rules=[
  [/\bBearer\s+[A-Za-z0-9._~+\/=-]{8,}/gi,'Bearer [REDACTED]'],
  [/\b(sk|nvapi|or|hf|ghp|xox[baprs])[-_][A-Za-z0-9._-]{8,}/gi,'[REDACTED_TOKEN]'],
  [/((api[_-]?key|token|secret|password|authorization)\s*[:=]\s*)[^\s,;]+/gi,'$1[REDACTED]'],
  [/([?&](?:key|token|secret|api_key)=)[^&\s]+/gi,'$1[REDACTED]'],
 ];
 for(const[r,v]of rules)text=text.replace(r,v);
 return text.slice(0,700);
}
export function uiProblems(){
 const s=store();if(!s)return[];
 try{const v=JSON.parse(s.getItem(KEY)||'[]');return Array.isArray(v)?v:[]}catch{return[]}
}
export function recordUiProblem(error,context='provider-market'){
 if(error?.name==='AbortError')return null;
 const s=store();if(!s)return null;
 const now=new Date().toISOString(),name=sanitizeDiagnosticText(error?.name||'Error'),
       message=sanitizeDiagnosticText(error?.message||String(error||'unknown'));
 const fingerprint=[context,name,message].join('|'),rows=uiProblems(),last=rows[0];
 if(last?.fingerprint===fingerprint&&Date.now()-Date.parse(last.last_seen_at||last.occurred_at)<15000){
   last.last_seen_at=now;last.count=(Number(last.count)||1)+1;
 }else rows.unshift({id:globalThis.crypto?.randomUUID?.()||`${Date.now()}-${Math.random()}`,occurred_at:now,last_seen_at:now,count:1,context,name,message,fingerprint,route:typeof window!=='undefined'?window.location.pathname+window.location.search:''});
 s.setItem(KEY,JSON.stringify(rows.slice(0,MAX)));
 if(typeof window!=='undefined')window.dispatchEvent(new Event('pmc-ui-problem-v3'));
 return rows[0]||null;
}
export function clearUiProblems(){const s=store();if(s)s.removeItem(KEY);if(typeof window!=='undefined')window.dispatchEvent(new Event('pmc-ui-problem-v3'))}
export function subscribeUiProblems(fn){
 if(typeof window==='undefined')return()=>{};
 const h=()=>fn(uiProblems());window.addEventListener('pmc-ui-problem-v3',h);window.addEventListener('storage',h);
 return()=>{window.removeEventListener('pmc-ui-problem-v3',h);window.removeEventListener('storage',h)};
}
